<template>
    <svg id="Layer_1" :height="height" :width="height" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 48 48">
        <path fill="none" d="M0,0H48V48H0Z"/>
        <path fill="#799cfb"
              d="M24,4A20,20,0,1,0,44,24,20,20,0,0,0,24,4ZM37.84,16h-5.9a31.3,31.3,0,0,0-2.76-7.12A16.06,16.06,0,0,1,37.84,16ZM24,8.08A28.17,28.17,0,0,1,27.82,16H20.18A28.17,28.17,0,0,1,24,8.08ZM8.52,28a15.64,15.64,0,0,1,0-8h6.76A33,33,0,0,0,15,24a33,33,0,0,0,.28,4Zm1.64,4h5.9a31.3,31.3,0,0,0,2.76,7.12A16,16,0,0,1,10.16,32Zm5.9-16h-5.9a16,16,0,0,1,8.66-7.12A31.3,31.3,0,0,0,16.06,16ZM24,39.92A28.17,28.17,0,0,1,20.18,32h7.64A28.17,28.17,0,0,1,24,39.92ZM28.68,28H19.32A29.43,29.43,0,0,1,19,24a29.17,29.17,0,0,1,.32-4h9.36A29.17,29.17,0,0,1,29,24,29.43,29.43,0,0,1,28.68,28Zm.5,11.12A31.3,31.3,0,0,0,31.94,32h5.9A16.06,16.06,0,0,1,29.18,39.12ZM32.72,28A33,33,0,0,0,33,24a33,33,0,0,0-.28-4h6.76a15.64,15.64,0,0,1,0,8Z"/>
    </svg>
</template>

<script>
    export default {
        name: "IGlobe",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
